import React, { useState } from "react";
import { Card, Grid } from "@material-ui/core";
import Cookies from 'universal-cookie';
import { saveAs } from "file-saver";

import { ButtonsGrid } from "../childrens/ButtonsGrid/.mixins";
import { Atributos } from "../childrens/Atributos/.mixins";
import { Modal } from "../childrens/Modal/.mixins";
import { IconsGrid } from "../childrens/IconsGrid/.mixins";

import Qualidade_controller from '../../../../controllers/qualidade';
import Config from '../../../../controllers/config';

import { CardContext } from "../context/CardContext";
import { css } from "./styles";

export function CardFichaTecnica(props) {
    const styles = css();

    const { tipo_card, atributos, pdf_link, produtos, upload_file, onClickViewModal, childAlert } = props;
    const { status } = atributos;

    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleClick = () => {
        if (atributos.status === "Pendente" && tipo_card === "a") {
            upload_file();
        } else {
            setIsModalOpen(!isModalOpen);
            if (onClickViewModal != null) {
                onClickViewModal(atributos);
            }
        }
    };

    const handleClickIconDownload = async (atributos, pdf_link) => {
      try {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        if (pdf_link == null || pdf_link === "") {
            props.childAlert.current.retorno('URL de arquivo vazia!', 'warning');
            return;
        }

        const query = { key: pdf_link, UserToken: token };
        const o_qualidade = await Qualidade_controller.getDownload(query);
        const o_qualidade_blob = await o_qualidade.blob();

        saveAs(
            o_qualidade_blob,
            `${atributos.alfa}_${atributos.nome_produto}.pdf`
        );
      } catch (error) {
        console.error(error);
      }
    };

    const handleClickIconPrint = async (pdf_link) => {
      try {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        if (pdf_link == null || pdf_link === "") {
            props.childAlert.current.retorno('URL de arquivo vazia!', 'warning');
            return;
        }

        const query = { key: pdf_link, UserToken: token };
        const o_qualidade = await Qualidade_controller.getDownload(query);
        const o_qualidade_blob = await o_qualidade.blob();

        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(o_qualidade_blob, "File.pdf"); //Apenas para IE
        } else {
            const fileURL = URL.createObjectURL(o_qualidade_blob);
            const iframe = document.createElement('iframe');
            document.body.appendChild(iframe);

            iframe.style.display = 'none';
            iframe.src = fileURL;
            iframe.onload = () => {
                setTimeout(() => {
                    iframe.focus();
                    iframe.contentWindow.print();
                }, 1);
            };
        }
      } catch (error) {
        console.error(error);
      }
    };

    return (
        <CardContext.Provider value={{ pdf_link, status, tipo_card }}>
            <Card className={styles.root}>
                <Grid container spacing={2} className={styles.container}>
                    <Grid item xs={6}>
                        <Atributos atributos={atributos} />
                    </Grid>

                    <Grid item xs={6} className={styles.right_side} >
                        <ButtonsGrid handleClick={handleClick} upload_file={upload_file} />

                        {(tipo_card === "m" && status === "Aprovado") &&
                            <IconsGrid
                                handleClickIconDownload={() => { handleClickIconDownload(atributos, pdf_link) }}
                                handleClickIconPrint={() => { handleClickIconPrint(pdf_link) }}
                            />
                        }
                    </Grid>
                </Grid>

                {tipo_card === "a" && (
                    <Modal
                        isModalOpen={isModalOpen}
                        handleClick={handleClick}
                        produtos={produtos}
                        atributos={atributos}
                        childAlert={childAlert}
                    />
                )}
            </Card>
        </CardContext.Provider>
    );
}
